var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[(_vm.$telemetryDataIsEnough)?_c('HeaderGameInformation',{attrs:{"id":"game"}}):_vm._e(),(_vm.$telemetryDataIsEnough)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuIsDisplayed),expression:"menuIsDisplayed"}],staticClass:"wrapper menu h-100"},[_c('Menu')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }